import React, { useState, useEffect } from 'react';
import CustomControl from '../../../../components/CustomControl/CustomControl';
import { FormattedMessage } from 'react-intl';
import { Button, Col, Row } from 'reactstrap';



export default ({ saveSettings, settings: { hash, date, url, status, sended, received, leadID, method }, toggleLogsSettingsModal }) => {
    const [enabledHash, toggleHashCheckbox] = useState(hash);
    const [enabledDate, toggleDateCheckbox] = useState(date)
    const [enabledUrl, toggleUrlCheckbox] = useState(url);
    const [enabledStatus, toggleStatusCheckbox] = useState(status)
    const [enabledSended, toggleSendedCheckbox] = useState(sended);
    const [enabledReceived, toggleReceivedCheckbox] = useState(received)
    const [enabledleadID, toggleleadIDCheckbox] = useState(leadID);
    const [enabledMethod, toggleMethodCheckbox] = useState(method)

    const [data, changeData] = useState({ hash, date, url, status, sended, received, leadID, method })


    const addSetting = ({ key, value }) => {
        changeData({ ...data, [key]: value })
    };

    const handleChooseEvery = () => {
        toggleHashCheckbox(true);
        toggleDateCheckbox(true);
        toggleUrlCheckbox(true);
        toggleStatusCheckbox(true);
        toggleSendedCheckbox(true);
        toggleReceivedCheckbox(true);
        toggleleadIDCheckbox(true)
        toggleMethodCheckbox(true)

        changeData({ hash: true, date: true, url: true, status: true, sended: true, received: true, leadID: true, method: true })
    }

    const handleRemoveSelections = () => {
        toggleHashCheckbox(true);
        toggleDateCheckbox(false);
        toggleUrlCheckbox(false);
        toggleStatusCheckbox(false);
        toggleSendedCheckbox(false);
        toggleReceivedCheckbox(false);
        toggleleadIDCheckbox(false)
        toggleMethodCheckbox(false)

        changeData({ hash: true, date: false, url: false, status: false, sended: false, received: false, leadID: false, method: false })
    }



    useEffect(() => addSetting({ key: 'hash', value: enabledHash }), [enabledHash])
    useEffect(() => addSetting({ key: 'date', value: enabledDate }), [enabledDate])
    useEffect(() => addSetting({ key: 'url', value: enabledUrl }), [enabledUrl])
    useEffect(() => addSetting({ key: 'status', value: enabledStatus }), [enabledStatus])
    useEffect(() => addSetting({ key: 'sended', value: enabledSended }), [enabledSended])
    useEffect(() => addSetting({ key: 'received', value: enabledReceived }), [enabledReceived])
    useEffect(() => addSetting({ key: 'leadID', value: enabledleadID }), [enabledleadID])
    useEffect(() => addSetting({ key: 'method', value: enabledMethod }), [enabledMethod])


    const saveBtnHandler = () => {
        saveSettings(data)
        toggleLogsSettingsModal(false);
    }

    return (
        <Row>
            <Col lg='4'>
                <Col lg='12'>
                    <CustomControl
                        id="logs-table-hash"
                        className="custom-control-xs no-margin"
                        label={'ID'}
                        onChange={() => {
                            toggleHashCheckbox(!enabledHash)
                        }}
                        checked={enabledHash}
                        inline
                    />
                </Col>
                <Col lg='12'>
                    <CustomControl
                        id="logs-table-leadID"
                        className="custom-control-xs no-margin"
                        label={<FormattedMessage id="postback.logs.leadID" defaultMessage="Order number" />}
                        onChange={() => {
                            toggleleadIDCheckbox(!enabledleadID)
                        }}
                        checked={enabledleadID}
                        inline
                    />
                </Col>
                <Col lg='12'>
                    <CustomControl
                        id="logs-table-date"
                        className="custom-control-xs no-margin"
                        label={<FormattedMessage id="postback.logs.date" defaultMessage="Date" />}
                        onChange={() => {
                            toggleDateCheckbox(!enabledDate)
                        }}
                        checked={enabledDate}
                        inline
                    />
                </Col>
            </Col>
            <Col lg='4'>
                <Col lg='12'>
                    <CustomControl
                        id="logs-table-url"
                        className="custom-control-xs no-margin"
                        label={'URL'}
                        onChange={() => {
                            toggleUrlCheckbox(!enabledUrl)
                        }}
                        checked={enabledUrl}
                        inline
                    />
                </Col>
                <Col lg='12'>
                    <CustomControl
                        id="logs-table-sended"
                        className="custom-control-xs no-margin"
                        label={<FormattedMessage id="postback.logs.sent3" defaultMessage="Settings of the request" />}
                        onChange={() => {
                            toggleSendedCheckbox(!enabledSended)
                        }}
                        checked={enabledSended}
                        inline
                    />
                </Col>
                <Col lg='12'>
                    <CustomControl
                        id="logs-table-method"
                        className="custom-control-xs no-margin"
                        label={<FormattedMessage id="postback.logs.method" defaultMessage="Postback method" />}
                        onChange={() => {
                            toggleMethodCheckbox(!enabledMethod)
                        }}
                        checked={enabledMethod}
                        inline
                    />
                </Col>
            </Col>
            <Col lg='4'>
                <Col lg='12'>
                    <CustomControl
                        id="logs-table-status"
                        className="custom-control-xs no-margin"
                        label={<FormattedMessage id="postback.logs.status" defaultMessage="Status" />}
                        onChange={() => {
                            toggleStatusCheckbox(!enabledStatus)
                        }}
                        checked={enabledStatus}
                        inline
                    />
                </Col>
                <Col lg='12'>
                    <CustomControl
                        id="logs-table-received"
                        className="custom-control-xs no-margin"
                        label={<FormattedMessage id="postback.logs.received3" defaultMessage="Response to the request" />}
                        onChange={() => {
                            toggleReceivedCheckbox(!enabledReceived)
                        }}
                        checked={enabledReceived}
                        inline
                    />
                </Col>
            </Col>
            <Col lg={{ size: 7, offset: 5 }} className='logs-settings-buttons'>
                <Button onClick={handleRemoveSelections} color="primary" outline size="sm"><FormattedMessage id="main.removeSelections" defaultMessage='Remove selections' /></Button>
                <Button onClick={handleChooseEvery} color="primary" outline size="sm" ><FormattedMessage id="main.selectAll" defaultMessage='Select all' /></Button>
                <Button onClick={saveBtnHandler} mr='1' color="primary" size="sm"><FormattedMessage id="main.save" defaultMessage='Save' /></Button>
            </Col>
        </Row >
    )
}